<template>
<div class="quick-page">
	<Header></Header> <!-- 头部 -->
	<div class="content">
		<div class="pd20 pt0">
			<div v-if="types=='qj'">
			<van-cell-group class="first mb20 subform">
				<van-cell title="申请人"   :value="details.person"/>
				<van-cell title="所属部门" :value="details.position" />
				<van-cell title="请假类型" :value="details.type" />
				<van-cell title="假期剩余" :value="details.remainlimit" />
				<van-cell title="开始时间" :value="details.beginTime.substr(0,16)" />
				<van-cell title="结束时间" :value="details.endTime.substr(0,16)" />
				<van-cell title="同部门请假人" :value="details.peePerson" />
				<van-cell title="请假原因" :value="details.reason" />
				<van-collapse v-model="activeNames" class="attache" v-if="attaches_list.length>0">
					<van-collapse-item name="1" style="padding:0px;">
						<template #title>
						   <div>附件</div>
						</template>
						<van-grid :border="false" :column-num="3">
						  <van-grid-item v-for="(item,index) in attaches_list">
							<van-image v-if="attache_houzhuis.includes(item.type)==true" :src="item.file" @click="showImage(index)" />
							<a v-else :href="item.file">
								<van-icon v-if="item.file.indexOf('pdf') !== -1" :name="WEB_URL+'images/icon-pdf.png'" size="50"/>
								<van-icon v-else-if="item.file.indexOf('xls') !== -1 || item.file.indexOf('xlsx') !== -1" :name="WEB_URL+'images/icon-excel.png'" size="50"/>
								<van-icon v-else-if="item.file.indexOf('doc') !== -1 || item.file.indexOf('docx') !== -1" :name="WEB_URL+'images/icon-doc.png'" size="50"/>
								<van-icon v-else name="envelop-o" size="50" color="#ddd" />
							</a>
						  </van-grid-item>
						</van-grid>
						<van-image-preview :start-position="image_start_position" v-model="is_image_show" :images="images"></van-image-preview>
					</van-collapse-item>
				</van-collapse>
				
			</van-cell-group>
			</div>
			<div v-else-if="types=='bk'">
				<van-cell-group class="first mb20">
					<van-cell title="申请人"   :value="details.person"/>
					<van-cell title="所属部门" :value="details.position" />
					<van-cell title="补卡时间" :value="details.time.substr(0,16)" />
					<van-cell title="证明人" :value="details.voucher" />
					<van-cell title="补卡原因" :value="details.reason" />
				</van-cell-group>
			</div>
			<div v-else>
				<van-cell-group class="first mb20">
					<van-cell title="申请人"   :value="details.person"/>
					<van-cell title="所属部门" :value="details.position" />
					<van-cell title="外出时长" :value="details.time"/>
					<van-cell title="外出类型" :value="details.type" />
					<van-cell title="同行人员" :value="details.peePerson" />
					<van-cell title="外出时间" :value="details.beginTime.substr(0,16)+'至'+details.endTime.substr(0,16)" />
					<van-cell title="外出原因" :value="details.reason" />
				</van-cell-group>
			</div>
			<div class="mb20 steps-items van-cell-group van-hairline--top-bottom">
				<div class="van-steps van-steps--vertical" style="font-size: 0.8rem;">
					<div class="van-steps__items">
						<div v-for="(item,index) in details.assigndetail" class="van-hairline van-step van-step--vertical van-step--process">
							<div class="van-step__title">
								<p>{{item.actdefname}}</p>
								<p><span style="color:#333;font-weight: 700;">{{item.person}}</span><span class="date right">{{item.time}}</span></p>
								<p>{{item.isPass}}</p>
							</div>
							<div class="van-step__circle-container">
								<i v-if="index==0 || details.assigndetail[index].isPass.indexOf('同意') !== -1" class="van-icon van-icon-checked van-step__icon"></i>
								<i v-else-if="details.assigndetail[index].isPass.indexOf('不同意') !== -1" class="van-icon no van-icon-clear van-step__icon"></i>
								<i v-else class="van-step__circle"></i>
							</div>
							<div class="van-step__line"></div>
						</div>
						<div v-if="details.billState.indexOf('已完成') !== -1" class="van-hairline van-step van-step--vertical van-step--process">
							<div class="van-step__title">
								<p><span style="color:#333;font-weight: 700;">已完成</span></p>
							</div>
							<div class="van-step__circle-container">
								<i class="van-icon van-icon-checked van-step__icon"></i>
							</div>
							<div class="van-step__line"></div>
						</div>		
					</div>
				</div>
			</div>
			<van-cell title="审批意见" class="last-t">
				<van-cell-group>
				  <van-field
					class="textarea"
					rows="2"
					type="textarea"
					name="reason"
					v-model="reason"
				  />
				</van-cell-group>
			</van-cell>
		</div>
		<div class="text-center btn-submit fixed bottom60" style="z-index:999;">
			<van-button @click="onSubmitEHR(false)" type="default" size="normal" class="mr20">拒绝</van-button>
			<van-button @click="onSubmitEHR(true)" type="info" size="normal">同意</van-button>
		</div>	
		<Footer></Footer> <!-- 尾部 -->
	</div>
</div>
</template>
<script type="text/javascript">
import axios from 'axios';
export default {
  created() {
  },
  mounted(){
  	var $rus=this.$router.history;
  	this.number=$rus["current"].query.number;
  	this.types=$rus["current"].query.types;
  	this.getDetail();
  },
  data() {
    return {
	  ADMIN:JSON.parse(localStorage.getItem('LS_ADMIN')),
	  WEB_URL:this.CoreNew.WEB_URL,
	  activeNames: ['0'],
	  reason:"",
	  type:3,
	  number:"",//单号
	  assignment:"",//提交单号
	  types:"qj",//qj查询补卡单为：bk，查询外出单为：wc
	  details: [],
	  attaches_list:[],
	  is_image_show: false,
	  image_start_position:0,
	  images:[],
	  attache_houzhuis: ['bmp','jpg','jpeg','png','tif','gif','pcx','tga','exif','fpx','svg','psd','cdr','pcd','dxf','ufo','eps','ai','raw','WMF','webp'],
	};
   },
   filters: {
		formatDateHM: function (value) {
		   let date = new Date(value);
		   let y = date.getFullYear();
		   let MM = date.getMonth() + 1;
		   MM = MM < 10 ? ('0' + MM) : MM;
		   let d = date.getDate();
		   d = d < 10 ? ('0' + d) : d;
		   let h = date.getHours();
		   h = h < 10 ? ('0' + h) : h;
		   let m = date.getMinutes();
		   m = m < 10 ? ('0' + m) : m;
		   let s = date.getSeconds();
		   s = s < 10 ? ('0' + s) : s;
		   return y + '-' + MM + '-' + d + ' ' + h + ':' + m;
		}
    },
    methods: {
	    showFiles: function (type,filename,content) {
			var myForm = document.createElement("form");     
	    	myForm.method = "post";
	    	myForm.action = this.CoreNew.WEB_PHP_URL+"showpdf.php"; 
	    	var myInputType = document.createElement("input");     
	    	myInputType.setAttribute("name", "type");  
	    	myInputType.setAttribute("value", type); 
	    	myForm.appendChild(myInputType);
	    	
	    	var myInputFilename = document.createElement("input");
	    	myInputFilename.setAttribute("name", "filename");  
	    	myInputFilename.setAttribute("value", filename); 
	    	myForm.appendChild(myInputFilename);
	    	
	    	var myInputContent = document.createElement("input");
	    	myInputContent.setAttribute("name", "content");  
	    	myInputContent.setAttribute("value", content); 
	    	myForm.appendChild(myInputContent);
	    	   
	    	document.body.appendChild(myForm);   
	    	myForm.submit(); 
	    	document.body.removeChild(myForm);
	    },
		showImage: function (index) {
	    	this.is_image_show=true;
	    	this.image_start_position=index;
	    },
		getDetail: function () {
		   let post_data = new FormData();
		   var str_json_data = '{"type":"3","types":"'+this.types+'","number":"'+this.number+'"}';
		   post_data.append("param",str_json_data);
		   axios.post(this.CoreNew.OA_API_IP+"joa-business/ehr/getLeaveParam/",post_data,{
		   	headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
		   }).then(function (response) {
		   	this.details=JSON.parse(response.data.data);
			this.assignment=this.details.assignment;
			if(this.details.files.length>0){
				this.attaches_list=this.details.files;
				for (var i = 0; i < this.details.files.length; i++) { 
					if(this.attache_houzhuis.includes(this.details.files[i].type)==true){
						this.images[i]=this.details.files[i].file;
						//this.images[i]='data:image/'+this.details.files[i].type+';base64,'+this.details.files[i].file;
					}
				}
			}
		   }.bind(this)).catch(function (error) { 
		   	//alert("请求EHR--获取员工假期--失败"+error);
		   	this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求EHR--获取单据详细信息--失败"+error);//记录错误
		   	console.log("请求EHR--获取单据详细信息--失败"+error);
		   }); 
	    },
		onSubmitEHR: function (isReject) {
			//提交
			$("#loading").show();
			var str_json_data = '{"assignment":"'+this.assignment+'","ispass":"'+isReject+'","opinion":"'+this.reason+'","penNumber":"'+this.ADMIN.USER_CODE+'"}';
			let post_data = new FormData();
			post_data.append("param",str_json_data);
			axios.post(this.CoreNew.OA_API_IP+"joa-business/ehr/passAssignment/",post_data,{
				headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
			}).then(function (response) {
				var $rs=JSON.parse(response.data.data);
				$("#loading").hide();
				if(response.data.flag==true && $rs.msg.indexOf("成功")==0){
					this.$toast("操作成功");
					var time = 2;
					var timer = setInterval(function() {
						time--;
						if(time == 0) {
							window.location.href=JSON.parse(localStorage.getItem('LS_WEB_URL'))+'list?sys=ehr';
							clearInterval(timer);//清楚定时
						}
					}, 1000);
				}else{
					this.$toast($rs.reson);
				}
			}.bind(this)).catch(function (error) { 
				$("#loading").hide();
				//alert("请求EHR--快捷审批--失败"+error);
				this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求EHR--快捷审批--失败"+error);//记录错误
				console.log("请求EHR--快捷审批--失败"+error);
			});
		}
    }
};
</script>
<style>
	.van-cell {
	    padding:10px 0px;
	}
</style>
